import React from 'react';
import { ChevronUp, ArrowRight, Check } from 'lucide-react';
import { Button } from '../ui/button';

// Footer of every configurator step: collapse arrow (left) + "Next step" (right)
export const StepFooter = ({ stepId, nextLabel, complete, onCollapse, onNext }) => (
  <div className="flex items-center justify-between gap-3 mt-4 px-2 pb-1" data-testid={`step-${stepId}-footer`}>
    <button
      type="button"
      onClick={onCollapse}
      className="inline-flex items-center gap-1 text-xs text-neutral-500 hover:text-neutral-900 transition-colors"
      title="Collapse this step"
      data-testid={`step-${stepId}-collapse`}
    >
      <ChevronUp className="w-4 h-4" />
      Collapse
    </button>
    {nextLabel ? (
      <Button
        size="sm"
        onClick={onNext}
        className={`h-8 gap-1.5 text-xs ${complete ? 'bg-neutral-900 hover:bg-neutral-800 text-white' : 'bg-white border border-neutral-300 text-neutral-700 hover:bg-neutral-50'}`}
        data-testid={`step-${stepId}-next`}
      >
        {complete && <Check className="w-3.5 h-3.5" />}
        Next step: {nextLabel}
        <ArrowRight className="w-3.5 h-3.5" />
      </Button>
    ) : (
      <Button size="sm" onClick={onNext} className="h-8 gap-1.5 text-xs bg-amber-600 hover:bg-amber-700 text-white" data-testid={`step-${stepId}-next`}>
        <Check className="w-3.5 h-3.5" />
        Done — review summary
      </Button>
    )}
  </div>
);
